import React from 'react'
import {IIncomeDocument} from '../IncomeDocumentDetailPage'
import {Col, Row} from 'react-bootstrap'
import {KTCard, KTCardBody} from '../../../../_metronic/helpers'
import {numberFormat} from '../../../utils/Functions'
import TabDocumentAccountBook, {GetAccountBook} from './TabDocumentAccountBook'

interface ITabDocumentExpenseAccountBook {
  document: IIncomeDocument
}

const TabDocumentExpenseAccountBook: React.FC<ITabDocumentExpenseAccountBook> = ({document}) => {
  // Each expense payment installment (งวด) carries its own account book(s) in the
  // already-loaded document payload. We aggregate them client-side (no extra API call).
  const payments = (document.incomeDocumentPayments || []).filter(
    (p: any) => p?.accountBooks?.length > 0
  )

  if (!payments.length) return <></>

  const formatPaymentDate = (dateString?: string) => {
    if (!dateString) return '-'
    return new Date(dateString).toLocaleDateString('th-TH', {
      day: '2-digit',
      month: '2-digit',
      year: 'numeric',
    })
  }

  return (
    <div>
      {payments.map((payment: any, paymentIndex: number) => (
        <KTCard className={'mb-4'} key={`payment-account-book-${payment?.id ?? paymentIndex}`}>
          <KTCardBody className={'py-3 px-4'}>
            <Row className={'fs-6 mb-3'}>
              <Col xs={12}>
                <h4 className={'mb-2'} style={{color: '#43bf76'}}>
                  {`จ่ายชำระเงินครั้งที่ ${paymentIndex + 1}`}
                </h4>
              </Col>
              <Col md={6}>
                <div className={'d-flex justify-content-between'}>
                  <strong>{'วันที่ :'}</strong>
                  <span>{formatPaymentDate(payment?.date)}</span>
                </div>
              </Col>
              <Col md={6}>
                <div className={'d-flex justify-content-between'}>
                  <strong>{'จำนวนเงิน :'}</strong>
                  <span>{`${numberFormat(payment?.amount || 0)} บาท`}</span>
                </div>
              </Col>
            </Row>
            {/*
              NOTE: payment.accountBooks items are typed `any` in the payload and the rest
              of the codebase only reads `.id`/`.code`. The payload may be PARTIAL relative
              to the full GetAccountBook shape — TabDocumentAccountBook is null-safe and
              renders '-' for any missing field while still showing the working link to
              /accountant/dailyJournalDetail/{id}. No new API call is introduced here.
            */}
            {payment.accountBooks.map((accountBook: any, abIndex: number) => (
              <div
                className={abIndex > 0 ? 'mt-3' : ''}
                key={`account-book-${accountBook?.id ?? abIndex}`}
              >
                <TabDocumentAccountBook accountBook={accountBook as GetAccountBook} />
              </div>
            ))}
          </KTCardBody>
        </KTCard>
      ))}
    </div>
  )
}

export default TabDocumentExpenseAccountBook
